// extracted by mini-css-extract-plugin
export default {"wrapper":"Resume_wrapper__pkP0W","printButton":"Resume_printButton__uw0AE"};